import applyThousandCommaSeparator from "../../utils/applyThousandCommaSeparator";

export default (latestValue, unit) => {
  if (!latestValue || !unit) return "--";

  const formattedValue = applyThousandCommaSeparator(latestValue);

  return `${formattedValue} ${unit}`;
};
